// extracted by mini-css-extract-plugin
export default {"sponsor":"sponsor__D07Oq"};